import { HUBSPOT_PLAN_REQUIRED_REASON } from "@productlane/lib/src/browser"

export type HubspotConnectFeedback =
	| { kind: "connected" }
	| { kind: "plan-required" }
	| { kind: "failed" }
	| null

export function getHubspotConnectFeedback(
	success: string | null,
	reason: string | null,
): HubspotConnectFeedback {
	if (success === "true") {
		return { kind: "connected" }
	}
	if (success === "false") {
		return reason === HUBSPOT_PLAN_REQUIRED_REASON
			? { kind: "plan-required" }
			: { kind: "failed" }
	}
	return null
}
